import React, { useEffect, useState } from 'react'
import { CustomModalBody, CustomTable } from '../CustomModalEmp'
import TimeTaxSupportSystemClient from '../../../system';
import { IColumn, Icon, PrimaryButton } from '@fluentui/react';
import { CustomTextFilEmpesas, ModalConfirm } from '../CustomTextFil';
import { useForm } from 'react-hook-form';
import { IlistCompanyobject, IsaveContactcompany, IupdateContactcompany } from '../../../system/company/Company';
import MessageCourier from '../../../lib/MessageCourier';
import { t } from 'i18next';

interface IcontactEmpresa {
    modal:boolean;
    setModal:(modal:boolean)=>void;
    empresaId:string | undefined;
    system:TimeTaxSupportSystemClient;
    uuid:string;
    changeBlockUI:(state: boolean) => void;
    courier:MessageCourier
}

function ContactEmpresa({modal,setModal,empresaId,system,uuid}:IcontactEmpresa) {
  const value :IlistCompanyobject = {empct_anexo:'',empct_cargo:'',empct_celular:'',empct_contact:'',empct_email:'',empct_telefono:'',empct_empid:'',empct_id:''};
  const {register,setValue,formState: { errors },watch,handleSubmit,clearErrors,reset} = useForm();
  const [listContact, setListContact] = useState<IlistCompanyobject[]>([]);
  const [detailContact, setDetailContact] = useState<IlistCompanyobject>();
  const [modificar, setModificar] = useState<boolean>(true);
  const [loadignTable , setLoadingTable] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(true);
  const [elimnar, setEliminar] = useState<{state:boolean,id:string}>({id:'',state:false});


  const columns: IColumn[] = [
    { key: 'column8', name: 'Eliminar', fieldName: 'Eliminar', minWidth: 60, isResizable: true, onRender: (value) => ( 
              <div style={{display:"flex",alignItems:"center",justifyContent:"center" ,color:"red",cursor:"pointer"}}>
                <Icon  style={{fontSize:"20px"}} iconName='Delete' onClick={()=>setEliminar({id:value.empct_id,state:true})}/>
              </div>)},
    { key: 'column9', name: 'Modificar', fieldName: 'Modificar', minWidth: 65, isResizable: true , onRender: (item) => ( 
              <div style={{display:"flex",alignItems:"center",justifyContent:"center" ,color:"#0078D4",cursor:"pointer"}}>
                <Icon style={{fontSize:"20px"}} iconName='SingleColumnEdit' onClick={()=>handlerdetailContact(item)}/>
              </div> )},
    { key: 'column1', name: 'Contacto', fieldName: 'empct_contact', minWidth: 80, isResizable: true },
    { key: 'column2', name: 'Cargo', fieldName:'empct_cargo', minWidth:80, isResizable:true},
    { key: 'column3', name: 'Email', fieldName: 'empct_email', minWidth: 80, isResizable: true },
    { key: 'column4', name: 'Celular', fieldName: 'empct_celular', minWidth: 80, isResizable: true },
    { key: 'column5', name: 'Teléfono', fieldName: 'empct_telefono', minWidth: 80, isResizable: true },
    { key: 'column6', name: 'Anexo', fieldName: 'empct_anexo', minWidth: 60, isResizable: true }
  ];

  const handlerDeleteContact = async ()=>{
     setEliminar({id:'',state:false});
     const result = await system.getCompanySystem().deleContactEmp(uuid,'listCompanycontact',elimnar.id);
     if(result.success) listCompanycontact();
  }

  const handlerdetailContact = (data)=>{
    clearErrors();
    setLoading(false);
    const value = data as IlistCompanyobject;
    setDetailContact(value);
    setModificar(false);
    setTimeout(()=>{
      setLoading(true)
    },500);
  }

  const handlerCleandetailContact = ()=>{
    clearErrors();
    setLoading(false);
    setDetailContact(value);
    setModificar(true);
    setTimeout(()=>{
      setLoading(true)
    },500);
  }

  const listCompanycontact = async()=>{
    if(!empresaId)return;
     const result = await system.getCompanySystem().listCompanyContact(uuid,'listCompanycontact',empresaId);

     result.success ? setListContact(result.data.reverse()):setListContact([]);
     setLoadingTable(false);
  }
  
  const HandlerSubmit = handleSubmit( async(data)=>{
    setLoading(false);
      const datosContact:IsaveContactcompany = {
         anexo:data.anexo,
         cargo:data.cargo,
         celular:data.celular,
         contacto:data.contacto,
         email:data.email,
         empid:empresaId!,
         telefono:data.telefono
      };
    if(modificar){
      const result = await system.getCompanySystem().saveContactcompany(datosContact,uuid,'save contact company');
      result.success &&  listCompanycontact();
      reset()
      setDetailContact(value);
    }else{
      const dataContacupdate:IupdateContactcompany = {...datosContact,empct_id:detailContact?.empct_id!}
      const result = await system.getCompanySystem().updateContactcompany(dataContacupdate,uuid,'update contact company');
      result.success &&  listCompanycontact();
      reset()
      setDetailContact(value);
      setModificar(true);
    }
      setLoading(true)
  });

  useEffect(()=>{
    register("contacto",{required:true,pattern:/^[A-Za-zÁÉÍÓÚáéíóúÑñ ]+$/});
    register("empid",{value:empresaId});
    register("cargo",{pattern:/^[A-Za-zÁÉÍÓÚáéíóúÑñ ]+$/});
    register("celular",{pattern:/^\+?\(?\d{1,3}\)? ?\d+([-.\s]?\d+)*$/});
    register("telefono",{pattern:/^\+?\(?\d{1,3}\)? ?\d+([-.\s]?\d+)*$/});
    register("anexo",{pattern:/^\d+$/});
    register("email",{required:true,pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,validate: async (ite) => {
      if(detailContact?.empct_email === ite){
        return true;
      }
      const validateEmail = await system.getCompanySystem().validateEmaiil(uuid,'validate email',ite,empresaId!);
      if(validateEmail.data){
        return false
      }  else{
        return true;
      }
    },});
  },[watch('email',loading)]);

  useEffect(()=>{
    listCompanycontact();
    return ()=>setListContact([]);
  },[]);

  return (
    <CustomModalBody icon='ContactInfo' hidden={modal} title='Contactos' onDismiss={()=>setModal(false)} minHeight={530} minWidth={810} >
    <div style={{  height: '200px', display: 'block', overflowY: 'auto',}}>
       <CustomTable columns={columns} items={listContact} loadign={loadignTable} />
    </div>
    <hr /> 
    {loading? <form onSubmit={HandlerSubmit} style={{ display:'flex',flexDirection:'column',gap:'50px', height:'180px'}}>
        <div style={{display:'flex',flexDirection:'row',gap:'20px'}}>
            <CustomTextFilEmpesas errors={errors} height='14px' label={t('Contacto(*)')} name='contacto' errormessage={t('El contacto no puede ser vacío')}
             placeholder={t('Escriba el contacto')} setValue={setValue} type='text' width='200px'key={'textFile1'} value={detailContact?.empct_contact}
             errorpattern={t('Este campo solo permite letras' )} />

            <CustomTextFilEmpesas errors={errors} height='14px' label={t('Cargo')} name='cargo'
             placeholder={t('Escriba el cargo')} setValue={setValue} type='text' width='200px' key={'textFile2'} value={detailContact?.empct_cargo} 
             errorpattern={t('Este campo solo permite letras')} />

            <CustomTextFilEmpesas errors={errors} height='14px' label={t('Email(*)')} name='email' errormessage={t('El email no puede ser vacío')}
             placeholder={t('Escriba el email')} setValue={setValue} type='text' width='200px'key={'textFile3'} value={detailContact?.empct_email}
             errorpattern={t('Este campo solo permite email')} errorvalidate={t('Este email ya existe')} />
        </div>
        <div style={{display:'flex',flexDirection:'row',gap:'20px'}} >
            <CustomTextFilEmpesas errors={errors} height='14px' label={t('Celular')} name='celular'
             placeholder={t('Escriba el celular')} setValue={setValue} type='text' width='200px'key={'textFile4'} value={detailContact?.empct_celular}
             errorpattern={t('Este campo solo permite numeros validos')} />

            <CustomTextFilEmpesas errors={errors} height='14px' label={t('Teléfono')} name='telefono'
             placeholder={t('Escriba el teléfono')} setValue={setValue} type='text' width='200px'key={'textFile5'} value={detailContact?.empct_telefono}
             errorpattern={t('Este campo solo permite numeros validos')} />

            <CustomTextFilEmpesas errors={errors} height='14px' label={t('Anexo')} name='anexo'
             placeholder={t('Escriba el anexo')} setValue={setValue} type='text' width='200px' key={'textFile6'} value={detailContact?.empct_anexo}
             errorpattern={t('este campo solo permite numeros')} />
        </div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center" }}>  {
        modificar?
            <PrimaryButton width="55" type="submit" style={{ marginTop:"10px"}} >{t('Agregar')}</PrimaryButton>: 
            <div style={{display:'flex',gap:"20px"}}>
                <PrimaryButton type="submit" style={{marginLeft:"10px", marginTop:"10px"}} >{t('Modificar')}</PrimaryButton>
                <PrimaryButton style={{ marginTop:"10px"}} onClick={handlerCleandetailContact} >{t('Cancelar')}</PrimaryButton> 
            </div>
        }</div>
    </form>
    :<div style={{display:"flex",justifyContent:"center"}}><div className="loader_Proyect"></div></div>
    }
    <ModalConfirm isOpen={elimnar.state} onClose={()=>setEliminar({id:'',state:false})} 
    onConfirm={handlerDeleteContact} message='Estas seguro que deseas eliminar el contacto' title={t('Eliminar')}  />
    </CustomModalBody>
  )
}

export default ContactEmpresa